export const CONFIRMATION_MODAL_TYPE = {
  EDIT: 'EDIT',
  REMOVE: 'REMOVE',
} as const
